export default {"src":"/_next/static/media/documents_24.959aa77c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};